import React from 'react';
import { clients } from '../mock';
import Reveal from './Reveal';
import { Building2, Users, Home, Briefcase, Hotel, HardHat } from 'lucide-react';

const iconFor = (name) => {
  const map = {
    'Architects & Interior Designers': Users,
    'Builders': HardHat,
    'Developers': Briefcase,
    'Hotels': Hotel,
    'Contractors': Building2,
    'Homeowners': Home,
  };
  return map[name] || Users;
};

const Clients = () => {
  return (
    <section id="clients" className="relative py-24 md:py-36 bg-[#FAF7F2]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="section-num text-sm">05 &mdash; Clients</span>
              <h2 className="mt-4 font-serif text-4xl md:text-5xl leading-[1.05] text-[#1a1a1a]">
                Trusted by <span className="italic">100+</span> Interior
                <br /> Designers &amp; Homeowners.
              </h2>
              <p className="mt-6 text-[#4a463f] text-[15px] leading-relaxed max-w-md">
                From developers and commercial clients to individual homeowners
                dreaming of a marble island &mdash; our stone finds the right home.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={150}>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
                {clients.map((c, i) => {
                  const Icon = iconFor(c);
                  return (
                    <div
                      key={c}
                      className="card-lift group flex flex-col items-start gap-3 bg-white rounded-sm p-5 md:p-6 border border-[#E5DED0]"
                    >
                      <div className="w-11 h-11 rounded-full bg-[#F1EBE1] flex items-center justify-center text-[#7B1E24] group-hover:bg-[#7B1E24] group-hover:text-white transition-colors duration-300">
                        <Icon size={18} strokeWidth={1.6} />
                      </div>
                      <div>
                        <div className="text-[11px] tracking-[0.24em] uppercase text-[#B8935A]">0{i + 1}</div>
                        <div className="mt-1 font-serif text-lg md:text-xl text-[#1a1a1a] leading-tight">{c}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clients;
